import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { WikiCardPageMode } from '../../models/wiki-card-model';

@UntilDestroy()
@Component({
  selector: 'wiki-card-draft-footer',
  templateUrl: './wiki-card-draft-footer.component.html',
  styleUrls: ['./wiki-card-draft-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WikiCardDraftFooterComponent {
  @Input() publishInProgress: boolean;
  @Input() pageMode: WikiCardPageMode;

  @Output() published = new EventEmitter<string>();

  @HostBinding('attr.pageMode')
  get pageModeAttr() {
    return this.pageMode;
  }

  publish() {
    if (this.publishInProgress) {
      return;
    }
    this.published.emit();
  }
}
